<template>
  <div>
    <a class="navbar-brand ps-2" href="#"><img src="@assets/images/logo-processus-c.svg" /></a>
    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarNav"
      aria-controls="navbarNav"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
  </div>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped></style>
